import { connect } from 'react-redux'
import ScreenShareScreen from './ScreenShareScreen'
import checkFocusedPresenter from '../../lib/checkFocusedPresenter'
import { stopScreenShare } from '../../dataStore/actions/ui/uiActions'
import selectEnabledScreenshareTracksForPresenter from '../../dataStore/selectors/selectEnabledScreenshareTracksForPresenter'
import { State } from '../../dataStore/reducers/reducerType'
import { ScreenShareScreenProps } from './types'
import { setAutoSpotlight, setMediaType } from '../../dataStore/actions/room/room'
import { mediaType as MediaType } from '@bt-react/constants'

const mapStateToProps = (state: State, props: Pick<ScreenShareScreenProps, 'presenter'>):
  Omit<ScreenShareScreenProps, 'onStop'> => {

  return {
    presenter: props.presenter,
    isBridge: !!state.config.bridgeName,
    isFocused: checkFocusedPresenter(props.presenter.BTID, state.room.focusOn),
    enabledVideoTracks: selectEnabledScreenshareTracksForPresenter(state, { presenter: props.presenter }),
    isPresenterLayoutsActive: state.layouts.presenterLayout.presenterLayoutsActive
  }

}

const mapDispatchToProps = dispatch => ({
  onStop: (layoutsActive: boolean, trackSid) => {
    if (layoutsActive) {
      dispatch(setAutoSpotlight(true))
      dispatch(setMediaType(MediaType.SPOTLIGHT))
    }
    dispatch(stopScreenShare(layoutsActive, trackSid))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ScreenShareScreen)
